import InlineErrors from '../Errors/InlineErrors.json'
import {alphabet, numeric, specialCharcaters} from '../../ProjectDetails/ProjectDescription/regexData'
import {emailCheck} from '../../UserManagement/regexData'

const handleInput = (setName, setErrorTextEnabled, setErrorText, name, namesList, currentName) => (event) => {
  function displayDuplicateErrorMsg() {
    setErrorTextEnabled(true)
    setErrorText(InlineErrors?.duplicateName)
  }
  const inputValue = event.target.value

  setName(inputValue)
  setErrorTextEnabled(false)
  if (name) {
    setName(inputValue?.charAt(0).toUpperCase() + inputValue?.slice(1).toLowerCase())
  }

  if (inputValue.match(alphabet)) {
    setErrorTextEnabled(false)
    if (namesList?.includes(inputValue)) {
      inputValue === currentName ? setErrorTextEnabled(false) : displayDuplicateErrorMsg()
    } else if (inputValue.trim() === '') {
      setErrorTextEnabled(true)
      setErrorText(InlineErrors.nameEmptyError)
    } else if (checkMaxCharacter(inputValue.length)) {
      setErrorTextEnabled(true)
      setErrorText(InlineErrors.characterLimitExceeded)
    }
  } else if (inputValue.match(numeric) && inputValue.match(specialCharcaters)) {
    setErrorTextEnabled(true)
    setErrorText(InlineErrors.numericAndSpecialCharsError)
  } else if (inputValue.match(numeric)) {
    setErrorTextEnabled(true)
    setErrorText(InlineErrors.numericValueInNameError)
  } else if (inputValue.match(specialCharcaters)) {
    setErrorTextEnabled(true)
    setErrorText(InlineErrors.speicalCharactersInNameError)
  } else {
    setErrorTextEnabled(true)
    setErrorText(InlineErrors.unknownError)
  }
}

const handleEmailAddressInput =
  (setEmailAddress, setErrorEmailAddressTextEnabled, setErrorEmailAddressText, emailList) => (event) => {
    setEmailAddress(event.target.value.trim().toLowerCase())
    if (event.target.value.trim() === '') {
      setErrorEmailAddressTextEnabled(true)
      setErrorEmailAddressText(InlineErrors.emailAddressEmptyError)
    } else if (event.target.value.match(emailCheck)) {
      setErrorEmailAddressTextEnabled(false)

      if (emailList?.includes(event.target.value.trim().toLowerCase())) {
        setErrorEmailAddressTextEnabled(true)
        setErrorEmailAddressText(InlineErrors.duplicateEmailError)
      }
    } else {
      setErrorEmailAddressTextEnabled(true)
      setErrorEmailAddressText(InlineErrors.invalidEmailError)
    }
  }
function checkMaxCharacter(value) {
  return value > 50
}
export {handleInput, handleEmailAddressInput}
